import without from 'lodash/without';
export const registerAction = (register, ...actions)=>process.env.BROWSER ? [
        ...register,
        ...actions
    ] : register;
export const unregisterAction = (register, ...actions)=>process.env.BROWSER ? without(register, ...actions) : register;
